import axios from 'axios';
import envService from './environmentService';
import store from '@/store';

export default class UserApiService {
  constructor () {
    this.http = axios.create();
    this.http.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';
  }

  sso (ssoToken) {
    var self = this;

    var url = `${this.getBaseUrl()}/sso/validate2`;
    return new Promise(function (resolve) {
      self.http({
        method: 'get',
        url: url,
        headers: { 'token': ssoToken },
        withCredentials: true
      }).then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          response.ok = false;
          resolve(response);
        }
      }).catch((e) => {
        let response = {
          code: 99,
          message: 'Unable to process request.'
        };

        resolve(response);
      });
    });
  }

  getAuthContext () {
    var self = this;
    var url = `${this.getBaseUrl()}/user/whoami`;

    return new Promise(function (resolve) {
      self.http({
        method: 'get',
        url: url,
        withCredentials: true
      }).then((response) => {
        if (response.status === 200) {
          store.dispatch('auth/setUserProfile', response.data);
        }

        resolve(response.data);
      }).catch(e => {
        resolve(null);
      });
    });
  }

  getBaseUrl () {
    var env = envService.getEnvironment();

    if (env === 'Local') {
      return 'https://userapi.hawksoft-dev.cloud';
    } else if (env === 'Development') {
      return 'https://userapi.hawksoft-dev.cloud';
    } else if (env === 'QA') {
      return 'https://userapi.hawksoft-qa.cloud';
    } else if (env === 'PO') {
      return 'https://userapi.hawksoft-po.cloud';
    } else if (env === 'Production') {
      return 'https://userapi.hawksoft.cloud';
    }

    return '<unable to determine user api url>';
  }
}
